<template>
  <div class="massaction-confirm-modal">
    <div class="confirm-modal-title">
      {{ $t("users.form.revokeUserFromDashboard") }}
    </div>
    <div class="confirm-modal-body">
      {{ $t("common.notes.areYouSureYouWant") }}
      <b>"{{ $t("common.revoke") }}"</b>
      {{ $t("users.form.usersFromDashboard") }}
    </div>

    <hr class="confirm-modal-divider" />
    <div class="d-flex justify-content-between w-60 m-auto">
      <button @click="revokeAction" class="confirm-modal-btn">
        {{ $t("common.revoke") }}
      </button>
      <button
        @click="$bvModal.hide('revoke-from-dashboard')"
        class="cancel-modal-btn"
      >
        {{ $t("common.cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  methods: {
    ...mapActions("users", ["revokeUsersFromDashboard"]),
    async revokeAction() {
      await this.revokeUsersFromDashboard(this.getModalInfo);
      this.$bvModal.hide("revoke-from-dashboard");
      this.$bvModal.show("revoke-confirm-modal");
    },
  },
};
</script>

<style lang="scss">
.massaction-confirm-modal {
  .confirm-modal-title {
    font-size: 17px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: start;
  }
  .confirm-modal-body {
    color: #787878;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: center;
    margin: 40px 0;
  }
  .confirm-modal-btn {
    background-color: #103f5e;
    color: #ffffff;

    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    border: 0;
    border-radius: 24px;
    width: 112px;
    height: 33px;
    // margin-top: 20px;
    // margin-inline-start: 145px;
  }
  .confirm-modal-divider {
    // margin: 0;
    margin-bottom: 20px;
  }
  .cancel-modal-btn {
    background-color: #ffffff;
    color: #f46a6a;
    border: 1px solid #f46a6a !important;
    width: 112px;
    height: 33px;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    border: 0;
    border-radius: 24px;
  }
  .w-60 {
    width: 60%;
  }
}
</style>
